export default "__VITE_ASSET__nveqh602__"